<section class="cbanner bannerbgcolor">
	<div class="container">
		<div class="row">
			<div
				class="col-xxl-12 col-xl-11 col-lg-11 col-md-11 col-ms-11 col-11 mx-auto"
				data-aos="fade-up"
				data-aos-duration="2000"
				data-aos-delay="100"
			>
				<!-- <img class="img-globe floatimg" src="{{baseUrl}}/img/3D-images/graphic.png" alt="Creative Graphic Design services in Dubai" width="" height="" loading="lazy"> -->
				<div id="spline-container">
					<!-- <canvas id="canvas" class="floatimg"></canvas> -->
					<div #canvas style="width: 100%; height: 100%" class="floatimg"></div>
				</div>
				<div class="banner vh-100">
					<div
						class="d-flex flex-column justify-content-center h-100 align-items-start"
					>
						<div
							class="contentbl"
							data-aos="fade-up"
							data-aos-duration="1000"
							data-aos-delay="100"
						>
							<h1 class="h1 size90">
								Elevate Your Brand with Unlimited Monthly<span class="barcely">
									Graphic </span
								>Designs
							</h1>
						</div>
					</div>
				</div>
				<div class="position-absolute banner-left-content content-left">
					<ul
						class="d-flex flex-column justify-contente-arround p-0 float-start"
						style="
							height: 130px;
							list-style: none;
							justify-content: space-between;
						"
					>
						<li>
							<a
								class=""
								href="https://www.instagram.com/pixtar.ae/"
								target="_blank"
								><img
									src="{{ baseUrl }}/img/home/social-media/instagram.svg"
									alt="Best Graphic Design for Luxury Brands"
									width="15"
									height=""
									loading="lazy"
							/></a>
						</li>
						<li>
							<a
								class=""
								href="https://www.facebook.com/pixtar.ae/"
								target="_blank"
								><img
									src="{{ baseUrl }}/img/home/social-media/facebook.svg"
									alt="Affordable Graphic Design Services for Small Businesses"
									width="10"
									height=""
									loading="lazy"
							/></a>
						</li>
						<li>
							<a
								class=""
								href="https://www.linkedin.com/company/pixtar-ae/"
								target="_blank"
								><img
									src="{{ baseUrl }}/img/home/social-media/linkedin.svg"
									alt="Custom Graphic Design services Dubai"
									width="15"
									height=""
									loading="lazy"
							/></a>
						</li>
						<li>
							<a
								class="whatsapp-icon2 slideUpReturn tabmob"
								href="https://wa.me/+971527930781"
								target="_blank"
							>
								<img
									src="{{ baseUrl }}/img/home/whatsapp.svg"
									alt="Professional Graphic Design for Digital Marketing"
									width="18"
									height=""
									loading="lazy"
								/>
							</a>
						</li>
					</ul>
					<div class="d-flex flex-column justify-contente-center left-content2">
						<p class="size24 textcolor1 lufgaregular">Design subscriptions for everyone.</p>
						<p class="size24 textcolor1 lufgaregular">Pause or cancel anytime.</p>
					</div>
				</div>
			</div>
		</div>

		<!-- <div class="position-absolute start-50 translate-middle down-arrow">
			<p>
				<a href="/services/graphics#packages" class="cstbtn package">
					<span class="text semibold"> Explore Packages</span>
					<span class="borderspan"
						><i class="fa fa-chevron-right" aria-hidden="true"></i>
					</span>
				</a>
			</p>
		</div> -->

		<div class="position-absolute translate-middle down-arrow bottom-0">
			<div class="linkToPackages">
				<a
					href="/services/graphics#packages"
					class="d-flex justify-content-start align-items-center"
				>
					<span class="text semibold text-capitalize"> Explore Packages </span>
					<i class="fa fa-chevron-right" aria-hidden="true"></i>
					<span class="borderspan"> </span>
				</a>
			</div>
		</div>
	</div>
</section>
<!-- Banner ends-->
<div class="bannerbgcolor cstheight"></div>
<section class="cstvideo">
	<div class="container-fluid">
		<div class="row">
			<div
				class="col-xxl-12 col-xl-11 col-lg-11 col-md-11 col-ms-11 col-11 mx-auto"
				[ngStyle]="{ width: sectionWidth + '%' }"
			>
				<div class="video-frame">
					<!-- <div class="overlay" onclick="this.nextElementSibling.style.display='block'; this.style.display='none'">
						<img src="{{ baseUrl }}/img/home/thumbnail-image.png" alt="Video thumbnail" class="w-100" />
						<div class="text-block text-center">
							<img class="" src="{{ baseUrl }}/img/home/play-icon.svg" alt="Achievement Image" />
						</div>
					</div> -->
					<!-- <iframe width="" height="680" id="aboutvideo"
						src="https://www.youtube.com/embed/2EVU53BXr_8?si=djmkfh_T2wJSfnWw" title="YouTube video player"
						frameborder="0" allow="accelerometer;  clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
						referrerpolicy="strict-origin-when-cross-origin" allowfullscreen style="width: 100%;"></iframe> -->
					<!-- <video class=" h-auto desktopimg" id="myVideo3" width="100%" height="400" autoplay="true" loop="true"
						oncanplay="this.play()" onloadedmetadata="this.muted = true" (click)="openPopup(videomodal)">
						<source src="{{baseUrl}}/what is brandng pixtar 2.mp4" type="video/mp4">
						<source src="{{baseUrl}}/what is brandng pixtar 2.mp4" type="video/ogg">
						Your browser does not support HTML5 video.
					</video> -->
					<video
						#myVideo
						width="100%"
						muted
						autoplay
						(click)="playInFullscreenWithAudio()"
						style="cursor: pointer"
					>
						<source
							src="{{ baseUrl }}/videos/graphic-page-video.mp4"
							type="video/mp4"
						/>
						<source
							src="{{ baseUrl }}/videos/graphic-page-video.mp4"
							type="video/ogg"
						/>
						Your browser does not support the video tag.
					</video>
				</div>
			</div>
		</div>
	</div>
</section>
<section class="aboutbrand mrem55 mb-0">
	<div class="container">
		<div class="row">
			<div
				class="col-xxl-12 col-xl-11 col-lg-11 col-md-11 col-ms-11 col-11 mx-auto"
			>
				<div class="about-brand">
					<h2 class="size55 weight300 light">
						<span class="textcolor1">
							Imagine never having to search for a designer again.</span
						>
						<span class="textcolor2">With Pixtar’s</span>
						<span class="barcely"> Graphic design </span>
						<span class="textcolor2">subscription,</span>
						<span class="textcolor1"> you get premium designs on demand</span>
						<span class="textcolor2">
							—crafted with care, precision, and zero templates.</span
						>
						<!-- <span class="textcolor1">make your story unforgettable.</span>
						<span class="barcely text-color"> Logo</span>.  -->
					</h2>
				</div>
			</div>
		</div>
	</div>
</section>
<!-- Recent works -->
<!-- <section class="topdist bannerdrk hard-work">
	<div
		class="container d-none d-sm-none d-md-block d-lg-block d-xl-block d-xxl-block"
	>
		<div class="row">
			<div class="col-xxl-12 col-xl-11 col-md-11 col-sm-11 col-11 mx-auto">
				<div class="d-flex justify-content-start align-items-center cmargin">
					<h2 class="text-white size32 bold ">
						<div class="line"></div>
						Recent Works
					</h2>
				</div>
			</div>
			<div class="col-xxl-12 col-xl-11 col-md-11 col-sm-11 col-11 mx-auto">
				<div class="row">
					<div
						class="col-md-6"
						*ngFor="let project of allprojects; let i = index"
					>
						<div class="imgblock">
							<a href="{{ project.link }}" target="_blank">
								<img
									src="{{ imagepath }}project/{{ project.image }}"
									alt="Creative Graphic Design for Social Media Campaigns"
									class="galleryimg{{ i }}"
									(mouseenter)="onMouseEnter(i)"
									(mouseleave)="onMouseLeave()"
									width=""
									height=""
									loading="lazy"
								/>
								<div class="box-name text-center">
									<p class="mb-0 textcolor5 h2 bold ">{{ project.name }}</p>
									<p class="textcolor4 light">
										<span [innerHTML]="project.desc"></span>
									</p>
								</div>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	recent work slider code
	<div
		class="customslider d-block d-sm-block d-md-none d-lg-none d-xl-none d-xxl-none"
		data-aos="fade-up"
		data-aos-duration="1000"
		data-aos-delay="100"
	>
		<div class="col-md-10 offset-md-1">
			<div class="d-flex justify-content-start align-items-center cmargin">
				<h2 class="text-white h1">
					<div class="line"></div>
					Recent Works
				</h2>
			</div>
		</div>
		<owl-carousel-o [options]="recentoptions">
			<ng-container *ngFor="let project of allprojects; let i = index">
				<ng-template carouselSlide [id]="project + i">
					<a href="{{ project.link }}" target="_self">
						<img
							src="{{ imagepath }}project/{{ project.project_images[0] }}"
							width=""
							height=""
							loading="lazy"
						/>
						<div class="box-name text-center">
							<p class="mb-0 textcolor5 h2">{{ project.name }}</p>
							<p class="textcolor4"><span [innerHTML]="project.desc"></span></p>
						</div>
					</a>
				</ng-template>
			</ng-container>
		</owl-carousel-o>
	</div>
	recent work slider code
	<div class="section bannerdrk container">
		<div class="row">
			<div class="col-md-10 m-auto">
				<div
					class="d-flex flex-column justify-content-center align-items-center video-block"
				>
					<div class="position-relative">
						<div class="float-start cwd243">
							<p>
								<a href="/contact/graphics" class="cstbtn cstbtn128 textcolor5">
									<span class="text fontsize14 text-white semibold">
										Book A Consultation
									</span>
									<span class="borderspan"
										><i class="fa fa-chevron-right" aria-hidden="true"></i
									></span>
								</a>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section> -->

<section class="topdist bannerdrk hard-work">
	<div class="container d-none d-md-block">
		<div class="row">
			<div class="col-11 mx-auto">
				<div class="d-flex justify-content-start align-items-center cmargin">
					<h3 class="text-white size32 bold">
						<div class="line"></div>
						Recent Works
					</h3>
				</div>
			</div>
			<div class="col-11 mx-auto">
				<div class="row">
					<div
						class="col-md-6"
						*ngFor="let project of allprojects; let i = index"
					>
						<div class="imgblock">
							<a href="{{ project.link }}" target="_blank">
								<img
									src="{{ imagepath }}project/{{ project.image }}"
									alt="{{ project.name }}"
									class="galleryimg{{ i }}"
									loading="lazy"
								/>
								<div class="box-name text-center">
									<p class="mb-0 textcolor5 h2 bold">{{ project.name }}</p>
									<p class="textcolor4 light">
										<span [innerHTML]="project.desc"></span>
									</p>
								</div>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div
		class="customslider d-block d-md-none px-5"
		data-aos="fade-up"
		data-aos-duration="1000"
	>
		<div class="col-md-10 offset-md-1">
			<div class="d-flex justify-content-start align-items-center cmargin">
				<h3 class="text-white h1">
					<div class="line"></div>
					Recent Works
				</h3>
			</div>
		</div>
		<owl-carousel-o [options]="recentoptions">
			<ng-container *ngFor="let project of allprojects; let i = index">
				<ng-template carouselSlide [id]="project + i">
					<a href="{{ project.link }}" target="_self">
						<img
							src="{{ imagepath }}project/{{ project.project_images[0] }}"
							loading="lazy"
						/>
						<div class="box-name text-center">
							<p class="mb-0 textcolor5 h2">{{ project.name }}</p>
							<p class="textcolor4"><span [innerHTML]="project.desc"></span></p>
						</div>
					</a>
				</ng-template>
			</ng-container>
		</owl-carousel-o>
	</div>

	<!-- <div class="section bannerdrk container">
		<div class="row">
			<div class="col-md-10 m-auto">
				<div
					class="d-flex flex-column justify-content-center align-items-center video-block"
				>
					<div class="position-relative">
						<div class="float-start cwd243">
							<p>
								<a href="/contact/graphics" class="cstbtn cstbtn128 textcolor5">
									<span class="text fontsize14 text-white semibold">
										Book A Consultation
									</span>
									<span class="borderspan"
										><i class="fa fa-chevron-right" aria-hidden="true"></i
									></span>
								</a>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div> -->
	<div class="section bannerdrk container p-0">
		<div class="row">
			<div class="col-md-10 m-auto">
				<div
					class="d-flex flex-column justify-content-center align-items-center video-block"
				>
					<div class="position-relative">
						<div class="float-start cwd243">
							<!-- <p>
								<a href="/contact/graphics" class="cstbtn cstbtn128 textcolor5">
									<span class="text fontsize14 text-white semibold">
										Book A Consultation
									</span>
									<span class="borderspan"
										><i class="fa fa-chevron-right" aria-hidden="true"></i
									></span>
								</a>
							</p> -->
							<div class="linkToPackages">
								<a
									href="/contact/graphics"
									class="d-flex justify-content-start align-items-center"
								>
									<span class="text semibold text-white text-capitalize">
										Book A Consultation
									</span>
									<i class="fa fa-chevron-right" aria-hidden="true"></i>
									<span class="borderspan"> </span>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<!-- Recent works -->
<!-- choose section starts -->

<section class="section choosesection">
	<div class="container position-relative">
		<div class="row">
			<div
				class="col-xxl-12 col-xl-11 col-lg-11 col-md-11 col-ms-11 col-11 mx-auto"
			>
				<div class="choose-section">
					<div class="col-md-6 col-sm-12 col-12 mx-auto">
						<div class="head-section pt-xxl-3 pt-xl-0">
							<h2
								class="textcolor1 size55 medium wght500 text-center mb-3 mt-0"
							>
								A Simple, Stress-Free Design Process
							</h2>
							<p class="size24 textcolor2 text-center">
								Say goodbye to hourly rates and unreliable freelancers. With
								Pixtar’s subscription, you get unlimited, high-quality graphic
								design—crafted from scratch, no templates, no limits.
							</p>
						</div>
						<!-- <div class="postion-relative mtrem5 mbrem5">
								<div class="position-absolute start-50 translate-middle down-arrow">
									<p>
										<a href="graphics#package" class="cstbtn"> <span class="text"> Subscribe Now</span> <span
												class="borderspan"><i class="fa fa-chevron-right" aria-hidden="true"></i>
											</span> </a>
									</p>
								</div>
							</div> -->
					</div>

					<!-- <p class="h1 weight300 text-center para">
						<span class="textcolor1 size55">What Makes Us Different?</span>
					</p> -->
					<div class="mtrem5">
						<div class="row">
							<div class="col-md-4">
								<div class="box text-center">
									<img
										class="mb-3"
										src="{{
											baseUrl
										}}/img/home/art-icons/subscribe-pixtar-graphic-design.gif"
										alt="Professional Graphic Design in Dubai"
										width=""
										height=""
										loading="lazy"
									/>
									<p class="size20 textcolor1 weight600 p1">Choose A Plan</p>
									<p class="size18 textcolor3 p2 text-center mx-auto">
										<!-- style="width: 242px" -->
										Pick a plan that fits your needs. The more credits, the more
										flexibility.
									</p>
								</div>
							</div>
							<div class="col-md-4 mt-md-0 mt-sm-4 mb-md-0 mb-sm-4 mb-4 mt-4">
								<div class="box text-center">
									<img
										class="mb-3"
										src="{{ baseUrl }}/img/home/art-icons/add-tasks.gif"
										alt="Graphic Design subscription"
										width=""
										height=""
										loading="lazy"
									/>
									<p class="size20 textcolor1 weight600 p1">Request A Design</p>
									<p class="size18 textcolor3 p2 text-center mx-auto">
										<!-- style="width: 242px" -->
										Got a project in mind? Send your request and we’ll start
										crafting.
									</p>
								</div>
							</div>
							<div class="col-md-4">
								<div class="box text-center">
									<img
										class="mb-3"
										src="{{ baseUrl }}/img/home/art-icons/relax.gif"
										alt="Premium Designs"
										width=""
										height=""
										loading="lazy"
									/>
									<p class="size20 textcolor1 weight600 p1">
										We Design, You Relax
									</p>
									<p class="size18 textcolor3 p2 text-center mx-auto">
										<!-- style="width: 242px" -->
										We’ll fine-tune the designs until you love them.
									</p>
								</div>
							</div>
						</div>
					</div>
					<div class="postion-relative mtrem5 mbrem5">
						<div class="position-absolute start-50 translate-middle down-arrow">
							<p>
								<a href="/contact/graphics" class="cstbtn subscribe">
									<span
										class="text fontsize14 semibold"
										style="letter-spacing: 0.23px !important"
									>
										Subscribe Now</span
									>
									<span class="borderspan"
										><i class="fa fa-chevron-right" aria-hidden="true"></i
									></span>
								</a>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<!-- choose section ends -->
<!-- <section class="section poster">
	<div class="container">
		<div class="row">
			<div
				class="col-xxl-12 col-xl-11 col-lg-11 col-md-11 col-ms-11 col-11 mx-auto"
			>
				<div class="choose-section">
					<div class="col-md-6 col-sm-11 col-11 mx-auto">
						<div class="">
							<div class="head-section pt-xxl-3 pt-xl-0">
								<h2 class="wght500 text-center mb-3 mt-0">
									<span class="textcolor1 size55 medium"
										>Pitch Decks, Posters, Social Media & more</span
									>
								</h2>
							</div>
						</div>
					</div>

					<div class="col-md-8 col-12 mx-auto">
						<div class="row">
							<div class="detail w-100 d-none d-sm-block mt-4">
								<ul
									class="d-flex flex-row justify-content-between justify-content-center align-items-center flex-wrap pl-0 mb-0 px-2"
								>
									<li>
										<input
											type="button"
											class="button"
											value="Landing Pages"
											disabled
										/>
									</li>
									<li>
										<input
											type="button"
											class="button"
											value="Posters"
											disabled
										/>
									</li>
									<li>
										<input
											type="button"
											class="button"
											value="Banners"
											disabled
										/>
									</li>
									<li>
										<input
											type="button"
											class="button"
											value="Brochures"
											disabled
										/>
									</li>
									<li>
										<input
											type="button"
											class="button"
											value="Rollups"
											disabled
										/>
									</li>
									<li>
										<input
											type="button"
											class="button"
											value="Standees"
											disabled
										/>
									</li>

									<li>
										<input
											type="button"
											class="button"
											value="Wall Graphics"
											disabled
										/>
									</li>
									<li>
										<input
											type="button"
											class="button"
											value="Presentation"
											disabled
										/>
									</li>
									<li>
										<input
											type="button"
											class="button"
											value="Decks"
											disabled
										/>
									</li>
									<li>
										<input
											type="button"
											class="button"
											value="+more"
											disabled
										/>
									</li>
									<li><input type="button" id='enterprise' class="button" (click)="selectSub('enterprise')" value="Enterprise Solution"></li>
									<li><input type="button" id='seo' class="button seo" (click)="selectSub('seo')" value="SEO"></li>
								</ul>
							</div>

							<div class="detail w-100 d-block d-sm-none mt-4">
								<ul
									class="d-flex flex-row justify-content-space-start align-items-center flex-wrap pl-0 mb-0"
								>
									<li>
										<input type="button" class="button" value="Landing Pages" />
									</li>
									<li>
										<input type="button" class="button" value="Posters" />
									</li>
									<li>
										<input type="button" class="button" value="Banners" />
									</li>
									<li>
										<input type="button" class="button" value="Brochures" />
									</li>
									<li>
										<input type="button" class="button" value="Rollups" />
									</li>
									<li>
										<input type="button" class="button" value="Standees" />
									</li>
									<li>
										<input type="button" class="button" value="Folders" />
									</li>
									<li>
										<input type="button" class="button" value="Wall Graphics" />
									</li>
									<li>
										<input type="button" class="button" value="Presentation" />
									</li>
									<li><input type="button" class="button" value="Decks" /></li>
									<li><input type="button" class="button" value="+more" /></li>
									<li><input type="button" id='enterprise' class="button" (click)="selectSub('enterprise')" value="Enterprise Solution"></li>
									<li><input type="button" id='seo' class="button" (click)="selectSub('seo')" value="SEO"></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section> -->

<section class="section poster">
	<div class="container">
		<div class="row">
			<div
				class="col-xxl-12 col-xl-11 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto"
			>
				<div class="choose-section">
					<div class="col-md-6 col-sm-11 col-11 mx-auto">
						<div class="head-section pt-xxl-3 pt-xl-0">
							<h2 class="wght500 text-center mb-3 mt-0">
								<span class="textcolor1 size55 medium">
									Pitch Decks, Posters, Social Media & more
								</span>
							</h2>
						</div>
					</div>

					<div class="col-md-8 col-12 mx-auto">
						<div class="row">
							<div class="detail w-100 mt-4">
								<ul
									class="d-flex flex-row justify-content-start justify-content-md-center align-items-center flex-wrap pl-0 mb-0 px-2"
								>
									<li>
										<input
											type="button"
											class="button"
											value="Landing Pages"
											disabled
										/>
									</li>
									<li>
										<input
											type="button"
											class="button"
											value="Posters"
											disabled
										/>
									</li>
									<li>
										<input
											type="button"
											class="button"
											value="Banners"
											disabled
										/>
									</li>
									<li>
										<input
											type="button"
											class="button"
											value="Brochures"
											disabled
										/>
									</li>
									<li>
										<input
											type="button"
											class="button"
											value="Rollups"
											disabled
										/>
									</li>
									<li>
										<input
											type="button"
											class="button"
											value="Standees"
											disabled
										/>
									</li>
									<li>
										<input
											type="button"
											class="button"
											value="Folders"
											disabled
										/>
									</li>
									<li>
										<input
											type="button"
											class="button"
											value="Wall Graphics"
											disabled
										/>
									</li>
									<li>
										<input
											type="button"
											class="button"
											value="Presentation"
											disabled
										/>
									</li>
									<li>
										<input
											type="button"
											class="button"
											value="Decks"
											disabled
										/>
									</li>
									<li>
										<input
											type="button"
											class="button"
											value="+more"
											disabled
										/>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<app-clients></app-clients>

<!-- choose section starts -->
<section class="section perks">
	<div class="container">
		<div class="row">
			<div
				class="col-xxl-12 col-xl-11 col-lg-11 col-md-11 col-ms-11 col-11 mx-auto"
			>
				<div class="choose-section">
					<!-- <p class="h1 weight300 text-center">
						<span class="textcolor1 size55">Membership Perks</span>
					</p> -->
					<div class="col-md-6 col-sm-11 col-11 mx-auto">
						<div class="">
							<div class="head-section pt-xxl-3 pt-xl-0">
								<h2 class="wght500 text-center mb-3 mt-0">
									<span class="textcolor1 size55 medium">Membership Perks</span>
								</h2>
								<p class="size24 textcolor2 text-center">
									Benefits so good, you’ll wonder why you ever looked elsewhere
									for design. Seriously!
								</p>
							</div>
						</div>
					</div>

					<div class="mt-3 section-perks">
						<div class="row">
							<div class="col-md-4">
								<div class="box text-center">
									<img
										class="mb30"
										src="{{ baseUrl }}/img/graphics/organized-workflow.gif"
										alt="high-quality graphic design"
										width=""
										height=""
										loading="lazy"
									/>
									<p class="size20 textcolor1 semibold p1">
										Organized Workflow
									</p>
									<p class="size18 textcolor3 p2">
										Easily oversee and manage your design tasks with a
										streamlined Trello board.
									</p>
								</div>
							</div>
							<div class="col-md-4 mt-md-0 mt-sm-4 mb-md-0 mb-sm-4 mb-4 mt-4">
								<div class="box text-center">
									<img
										class="mb30"
										src="{{ baseUrl }}/img/graphics/speedy-delivery.gif"
										alt="graphic designs for landing pages"
										width=""
										height=""
										loading="lazy"
									/>
									<p class="size20 textcolor1 semibold p1">Speedy Delivery</p>
									<p class="size18 textcolor3 p2">
										Receive your designs one at a time, typically within just a
										few days.
									</p>
								</div>
							</div>
							<div class="col-md-4">
								<div class="box text-center">
									<img
										class="mb30"
										src="{{ baseUrl }}/img/graphics/transparent-pricing.gif"
										alt="graphic designs for posters"
										width=""
										height=""
										loading="lazy"
									/>
									<p class="size20 textcolor1 semibold p1">
										Transparent Pricing
									</p>
									<p class="size18 textcolor3 p2">
										Say goodbye to surprises! Enjoy a consistent, fixed monthly
										fee.
									</p>
								</div>
							</div>
							<div class="col-md-4">
								<div class="box text-center">
									<img
										class="mb30"
										src="{{ baseUrl }}/img/graphics/exceptional-quality.gif"
										alt="unlimited stock photos"
										width=""
										height=""
										loading="lazy"
									/>
									<p class="size20 textcolor1 semibold p1">
										Exceptional Quality
									</p>
									<p class="size18 textcolor3 p2">
										Access top-tier designs whenever you need them, crafted with
										precision and care.
									</p>
								</div>
							</div>
							<div class="col-md-4 mt-md-0 mt-sm-4 mb-md-0 mb-sm-4 mb-4 mt-4">
								<div class="box text-center">
									<img
										class="mb30"
										src="{{ baseUrl }}/img/graphics/flexible-adaptable.gif"
										alt="Custom Graphic Design"
										width=""
										height=""
										loading="lazy"
									/>
									<p class="size20 textcolor1 semibold p1">
										Flexible & Adaptable
									</p>
									<p class="size18 textcolor3 p2">
										Scale up or down as needed, with the freedom to pause or
										cancel anytime.
									</p>
								</div>
							</div>
							<div class="col-md-4">
								<div class="box text-center">
									<img
										class="mb30"
										src="{{ baseUrl }}/img/graphics/completely-yours.gif"
										alt="premium Designs"
										width=""
										height=""
										loading="lazy"
									/>
									<p class="size20 textcolor1 semibold p1">Completely Yours</p>
									<p class="size18 textcolor3 p2">
										Every design is custom-made for you and is 100% owned by
										you.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<!-- choose section ends -->

<!-- packages section Start -->
<section class="section packages pt-0 backeeedf0">
	<div class="container">
		<div class="row">
			<div class="col-md-6 col-sm-11 col-11 mx-auto">
				<div class="packages-section mbrem5 mtrem5">
					<h2 class="wght500 text-center mb-3 mt-0">
						<span class="textcolor1 size55 medium"
							>Plans Designed to Fit Every Need</span
						>
					</h2>
					<p class="size24 textcolor2 text-center">
						Whether you’re a startup, a growing business, or an enterprise,
						we’ve got a plan for you. Each credit gives you access to premium
						design services—crafted to perfection using the golden ratio
					</p>
				</div>
			</div>
			<div
				class="col-lg-11 col-md-10 col-sm-11 col-11 mx-auto"
				id="packages"
				#packages
			>
				<div class="row justify-content-center">
					<div class="col-xxl-5 col-xl-5 col-lg-8 col-md-10">
						<div class="card bgblk h-100">
							<div class="card-body">
								<div class="brd">
									<div class="d-flex">
										<div class="icons">
											<div class="circle1 pulse"></div>
											<div class="circle2"></div>
										</div>
										<div class="text">
											<p class="fontsize14 textcolor3">Slots available</p>
										</div>
									</div>
								</div>
								<h2 class="textcolor3 size90 fw-light">Join</h2>
								<h2 class="size90 weight700 text-white mt-0 mb-4">Pixtar</h2>
								<div class="box mb-2">
									<h3 class="text-white weight500 mb-2 mt-0 size24">
										Book a 15-min intro Call
									</h3>
									<p class="size18 textcolor3">
										Learn more about how Pixtar
										<span class="d-block"> works and how it can help you.</span>
									</p>
									<!-- <a href="/contact/graphics" class="cstbtn">
										<span class="borderspan"
											><i class="fa fa-chevron-right" aria-hidden="true"></i
										></span>
									</a> -->
									<a
										href="/contact/graphics"
										class="cstbtn"
										aria-label="Contact Us for Graphics Services"
									>
										<span class="borderspan">
											<i class="fa fa-chevron-right" aria-hidden="true"></i>
										</span>
									</a>
								</div>
								<div class="box">
									<h3 class="text-white weight500 mb-2 mt-0 size24">
										Refer a friend & earn
									</h3>
									<p class="size18 textcolor3 position-relative">
										Earn 5% monthly recurring
										<span class="d-block"> commission for each referral.</span>

										<!-- <button (click)="openModal()" class="cstbtn">
											<span class="text text-white"> Get Started</span>
											<span class="borderspan"
												><i class="fa fa-chevron-right" aria-hidden="true"></i>
											</span>
										</button> -->

										<a
											(click)="openModal()"
											(keydown.enter)="openModal()"
											(keydown.space)="openModal()"
											class="cstbtn top-0"
											role="button"
											tabindex="0"
											aria-label="Get Started - Refer a friend"
										>
											<span class="borderspan">
												<i class="fa fa-chevron-right" aria-hidden="true"></i>
											</span>
										</a>
									</p>
								</div>
							</div>
						</div>
					</div>
					<!-- whit card design -->
					<div
						class="col-xxl-7 col-xl-7 col-lg-8 col-md-10 mt-xl-0 mt-lg-5 mt-md-5 mt-sm-5 mt-5"
					>
						<div class="card shadow" style="max-width: 600px">
							<h3 class="text-start py-3 medium size32">{{ tabTitle }}</h3>
							<nav>
								<div class="nav nav-tabs mb-3" id="nav-tab" role="tablist">
									<button
										class="nav-link active"
										id="nav-home-tab"
										data-bs-toggle="tab"
										data-bs-target="#nav-home"
										type="button"
										role="tab"
										aria-controls="nav-home"
										aria-selected="true"
										(click)="changeTabTitle('For Startups')"
									>
										Explorer
									</button>
									<button
										class="nav-link"
										id="nav-profile-tab"
										data-bs-toggle="tab"
										data-bs-target="#nav-profile"
										type="button"
										role="tab"
										aria-controls="nav-profile"
										aria-selected="false"
										(click)="changeTabTitle('For Growing Businesses.')"
									>
										<!-- <i class="fa fa-bolt" aria-hidden="true"></i> -->
										<img
											src="{{ baseUrl }}/img/services/shock.png"
											alt="Graphic Design Solutions"
											width=""
											height=""
											loading="lazy"
										/>
										Pro
									</button>
									<button
										class="nav-link"
										id="nav-contact-tab"
										data-bs-toggle="tab"
										data-bs-target="#nav-contact"
										type="button"
										role="tab"
										aria-controls="nav-contact"
										aria-selected="false"
										(click)="changeTabTitle('For Agencies & Large Teams')"
									>
										Enterprise
									</button>
								</div>
							</nav>

							<div class="tab-content" id="nav-tabContent">
								<div
									class="tab-pane fade active show"
									id="nav-home"
									role="tabpanel"
									aria-labelledby="nav-home-tab"
								>
									<div class="cstprng-table">
										<div class="cstprng-table-header">
											<h4
												class="cstprng-table-cost size55 textcolor1 weight500 mt-0"
												*ngIf="price_exp"
											>
												{{ price_exp.currency }} {{ price_exp.amount }}
											</h4>

											<div class="custom-toggle d-flex justify-content-end">
												<span class="bggrey d-flex">
													<button
														class="nav-link {{ activecls_aed }}"
														type="button"
														(click)="changeCurrency('AED')"
													>
														AED
													</button>

													<button
														class="nav-link {{ activecls_usd }}"
														type="button"
														(click)="changeCurrency('USD')"
													>
														AED
													</button>

													<!-- <button
														class="nav-link {{ activecls_aed }}"
														type="button"
														aria-selected="false"
														(click)="changeCurrency('AED')"
													>
														AED
													</button>
													<button
														class="nav-link {{ activecls_usd }}"
														type="button"
														aria-selected="false"
														(click)="changeCurrency('USD')"
													>
														USD
													</button> -->
												</span>
											</div>

											<h5
												class="cstprng-table-about size24 textcolor1 weight500"
											>
												One request at a time, Pause or cancel anytime.
											</h5>
										</div>
										<div class="divider"></div>
										<div class="cstprng-table-features">
											<h5 class="size24 textcolor1 weight500">
												What’s included
											</h5>
											<div class="row">
												<div class="col-md-6">
													<ul class="list-group">
														<li
															class="list-group-item d-flex size18 justify-content-start align-items-center border-0 p-0 mb-2"
														>
															<i class="fa fa-check me-2"></i>One requests at a
															time
														</li>
														<li
															class="list-group-item d-flex size18 justify-content-start align-items-center border-0 p-0 mb-2"
														>
															<i class="fa fa-check me-2"></i>Average 48 hour
															delivery
														</li>
														<li
															class="list-group-item d-flex size18 justify-content-start align-items-center border-0 p-0 mb-2"
														>
															<i class="fa fa-check me-2"></i>Unlimited brands
														</li>
													</ul>
												</div>
												<div class="col-md-6">
													<ul class="list-group">
														<li
															class="list-group-item size18 d-flex justify-content-start align-items-center border-0 p-0 mb-2"
														>
															<i class="fa fa-check me-2"></i>Adobe .Ai .Ps .Xd
														</li>
														<li
															class="list-group-item d-flex size18 justify-content-start align-items-center border-0 p-0 mb-2"
														>
															<i class="fa fa-check me-2"></i>Dedicated Account
															Manager
														</li>
														<li
															class="list-group-item d-flex size18 justify-content-start align-items-center border-0 p-0 mb-2"
														>
															<i class="fa fa-check me-2"></i>Pause or cancel
															anytime
														</li>
													</ul>
												</div>
											</div>
										</div>
										<div
											class="cstprng-table-cta position-relative mtrem3 started"
										>
											<!-- <div
												class="position-absolute start-50 translate-middle down-arrow"
											>
												<p *ngIf="price_exp">
													<a
														(click)="
															getStripPayemts(
																price_exp.name,
																price_exp.amount,
																payments,
																price_exp.productId
															)
														"
														class="cstbtn"
													>
														<span class="text semibold fontsize14">
															Get Started</span
														>
														<span class="borderspan"
															><i
																class="fa fa-chevron-right"
																aria-hidden="true"
															></i>
														</span>
													</a>
												</p>
											</div> -->

											<div class="linkToPackages">
												<p *ngIf="price_exp">
													<button
														(click)="
															getStripPayemts(
																price_exp.name,
																price_exp.amount,
																payments,
																price_exp.productId
															)
														"
														class="d-flex justify-content-start align-items-center"
													>
														<span class="text semibold text-capitalize"
															>Get Started</span
														>
														<i
															class="fa fa-chevron-right"
															aria-hidden="true"
														></i>
														<span class="borderspan"> </span>
													</button>
												</p>
											</div>

											<p class="fontsize14 medium cntlink">
												Or
												<a
													href="/contact/graphics"
													class="text-decoration-underline fontsize14 medium"
												>
													book a call
												</a>
											</p>
										</div>
									</div>
								</div>
								<!-- explore end -->

								<!-- pro start -->
								<div
									class="tab-pane fade"
									id="nav-profile"
									role="tabpanel"
									aria-labelledby="nav-profile-tab"
								>
									<div class="cstprng-table">
										<div class="cstprng-table-header">
											<h4
												class="cstprng-table-cost size55 textcolor1 weight500 mt-0"
												*ngIf="price_pro"
											>
												{{ price_pro.currency }} {{ price_pro.amount }}
											</h4>
											<div class="custom-toggle d-flex justify-content-end">
												<span class="bggrey d-flex">
													<button
														class="nav-link {{ activecls_aed }}"
														type="button"
														aria-selected="false"
														(click)="changeCurrency('AED')"
													>
														AED
													</button>
													<button
														class="nav-link {{ activecls_usd }}"
														type="button"
														aria-selected="false"
														(click)="changeCurrency('USD')"
													>
														USD
													</button>
												</span>
											</div>
											<h5
												class="cstprng-table-about size20 textcolor1 weight500"
											>
												Double the requests. Pause or cancel anytime.
											</h5>
										</div>
										<div class="divider"></div>
										<div class="cstprng-table-features">
											<h5 class="size20 textcolor1 weight500">
												What’s included
											</h5>
											<div class="row">
												<div class="col-md-6">
													<ul class="list-group">
														<li
															class="list-group-item d-flex size18 justify-content-start align-items-center border-0 p-0 mb-2"
														>
															<i class="fa fa-check me-2"></i>Two requests at a
															time
														</li>
														<li
															class="list-group-item d-flex justify-content-start align-items-center border-0 p-0 mb-2"
														>
															<i class="fa fa-check me-2"></i>Average 48 hour
															delivery
														</li>
														<li
															class="list-group-item d-flex justify-content-start align-items-center border-0 p-0 mb-2"
														>
															<i class="fa fa-check me-2"></i>Unlimited brands
														</li>
														<li
															class="list-group-item d-flex justify-content-start align-items-center border-0 p-0 mb-2"
														>
															<i class="fa fa-check me-2"></i>XD UI design
														</li>
													</ul>
												</div>
												<div class="col-md-6">
													<ul class="list-group">
														<li
															class="list-group-item d-flex justify-content-start align-items-center border-0 p-0 mb-2"
														>
															<i class="fa fa-check me-2"></i>15 stock photos
														</li>
														<li
															class="list-group-item d-flex justify-content-start align-items-center border-0 p-0 mb-2"
														>
															<i class="fa fa-check me-2"></i>Unlimited users
														</li>
														<li
															class="list-group-item d-flex justify-content-start align-items-center border-0 p-0 mb-2"
														>
															<i class="fa fa-check me-2"></i>Dedicated Account
															Manager
														</li>
														<li
															class="list-group-item d-flex justify-content-start align-items-center border-0 p-0 mb-2"
														>
															<i class="fa fa-check me-2"></i>Pause or cancel
															anytime
														</li>
													</ul>
												</div>
											</div>
										</div>
										<div
											class="cstprng-table-cta position-relative mtrem3 started"
										>
											<!-- <div
												class="position-absolute start-50 translate-middle down-arrow"
											>
												<p *ngIf="price_pro">
													<a
														(click)="
															getStripPayemts(
																price_pro.name,
																price_pro.amount,
																payments,
																price_pro.productId
															)
														"
														class="cstbtn"
													>
														<span class="text"> Get Started</span>
														<span class="borderspan"
															><i
																class="fa fa-chevron-right"
																aria-hidden="true"
															></i>
														</span>
													</a>
												</p>
											</div> -->

											<div class="linkToPackages">
												<p *ngIf="price_pro">
													<button
														(click)="
															getStripPayemts(
																price_pro.name,
																price_pro.amount,
																payments,
																price_pro.productId
															)
														"
														class="d-flex justify-content-start align-items-center"
													>
														<span class="text semibold text-capitalize"
															>Get Started</span
														>
														<i
															class="fa fa-chevron-right"
															aria-hidden="true"
														></i>
														<span class="borderspan"> </span>
													</button>
												</p>
											</div>

											<p class="size14 cntlink">
												Or
												<a
													href="/contact/graphics"
													class="text-decoration-underline"
													>book a call</a
												>
											</p>
										</div>
									</div>
								</div>
								<!-- pro end -->

								<!-- enterprises start -->
								<div
									class="tab-pane fade"
									id="nav-contact"
									role="tabpanel"
									aria-labelledby="nav-contact-tab"
								>
									<div class="cstprng-table">
										<div class="cstprng-table-header">
											<h4
												class="cstprng-table-cost size55 textcolor1 weight500 mt-0"
												*ngIf="price_ent"
											>
												{{ price_ent.currency }} {{ price_ent.amount }}
											</h4>
											<div class="custom-toggle d-flex justify-content-end">
												<span class="bggrey d-flex">
													<button
														class="nav-link {{ activecls_aed }}"
														type="button"
														aria-selected="false"
														(click)="changeCurrency('AED')"
													>
														AED
													</button>
													<button
														class="nav-link {{ activecls_usd }}"
														type="button"
														aria-selected="false"
														(click)="changeCurrency('USD')"
													>
														USD
													</button>
												</span>
											</div>
											<h5
												class="cstprng-table-about size20 textcolor1 weight500"
											>
												For Agencies and Large Teams.
											</h5>
										</div>
										<div class="divider"></div>
										<div class="cstprng-table-features">
											<h5 class="size20 textcolor1 weight500">
												What’s included
											</h5>
											<div class="row">
												<div class="col-md-6">
													<ul class="list-group">
														<li
															class="list-group-item d-flex justify-content-start align-items-center border-0 p-0 mb-2"
														>
															<i class="fa fa-check me-2"></i>10 requests at a
															time
														</li>
														<li
															class="list-group-item d-flex justify-content-start align-items-center border-0 p-0 mb-2"
														>
															<i class="fa fa-check me-2"></i>Same-day
															turnaround
														</li>
														<li
															class="list-group-item d-flex justify-content-start align-items-center border-0 p-0 mb-2"
														>
															<i class="fa fa-check me-2"></i>Unlimited brands
														</li>
														<li
															class="list-group-item d-flex justify-content-start align-items-center border-0 p-0 mb-2"
														>
															<i class="fa fa-check me-2"></i>XD UI design
														</li>
													</ul>
												</div>
												<div class="col-md-6">
													<ul class="list-group">
														<li
															class="list-group-item d-flex justify-content-start align-items-center border-0 p-0 mb-2"
														>
															<i class="fa fa-check me-2"></i>Unlimited stock
															photos
														</li>
														<li
															class="list-group-item d-flex justify-content-start align-items-center border-0 p-0 mb-2"
														>
															<i class="fa fa-check me-2"></i>Unlimited users
														</li>
														<li
															class="list-group-item d-flex justify-content-start align-items-center border-0 p-0 mb-2"
														>
															<i class="fa fa-check me-2"></i>Dedicated Creative
															Director & Slack Support.
														</li>
														<li
															class="list-group-item d-flex justify-content-start align-items-center border-0 p-0 mb-2"
														>
															<i class="fa fa-check me-2"></i>Pause or cancel
															anytime
														</li>
													</ul>
												</div>
											</div>
										</div>
										<div
											class="cstprng-table-cta position-relative mtrem3 started"
										>
											<!-- <div
												class="position-absolute start-50 translate-middle down-arrow"
											>
												<p *ngIf="price_ent">
													<a
														(click)="
															getStripPayemts(
																price_ent.name,
																price_ent.amount,
																payments,
																price_ent.productId
															)
														"
														class="cstbtn"
													>
														<span class="text"> Get Started</span>
														<span class="borderspan"
															><i
																class="fa fa-chevron-right"
																aria-hidden="true"
															></i>
														</span>
													</a>
												</p>
											</div> -->

											<div class="linkToPackages">
												<p *ngIf="price_ent">
													<button
														(click)="
															getStripPayemts(
																price_pro.name,
																price_pro.amount,
																payments,
																price_pro.productId
															)
														"
														class="d-flex justify-content-start align-items-center"
													>
														<span class="text semibold text-capitalize"
															>Get Started</span
														>
														<i
															class="fa fa-chevron-right"
															aria-hidden="true"
														></i>
														<span class="borderspan"> </span>
													</button>
												</p>
											</div>

											<p class="size14 cntlink">
												Or
												<a
													href="/contact/graphics"
													class="text-decoration-underline"
													>book a call</a
												>
											</p>
										</div>
									</div>
								</div>
								<!-- enterprises end -->
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-5 col-md-7 col-sm-11 col-11 mx-auto">
				<div class="subscription-section mtrem5">
					<h2 class="wght500 text-center mb-3 mt-0">
						<span class="textcolor1 size55">Your Subscription, Your Way</span>
					</h2>
					<p class="size24 textcolor2 text-center">
						Got a busy month and need more credits? No problem. You can top-up
						anytime or upgrade your plan on the fly
					</p>
				</div>
			</div>
		</div>
	</div>
</section>
<!-- packages section ends -->

<!-- Successful story sections-->
<!-- <section class="success-story bannerdrk">
	<div class="container">
		<div class="row">
			<div class="col-xxl-12 col-xl-11 col-lg-11 col-md-11 col-ms-11 col-11 mx-auto">
				<div class="content mbrem8">

				</div>
				<owl-carousel-o [options]="desktopslider">
					<ng-container>
						<ng-template carouselSlide [id]="baseUrl">
							<div class="col-md-9 col-sm-11 col-11 mx-auto">
								<div class="row justify-content-center">
									<div class="col-lg-3 col-md-5 col-sm-5">
										<div class="imgblk">
											<img class="" src="{{baseUrl}}/img/home/hiral-krupesh.png" alt="Branding and web development agency">
										</div>
									</div>
									<div class="col-lg-8 col-md-7 offset-lg-1 col-sm-7 mt-sm-0 mt-3">
										<div class="slidecontent">
											<p class="fontsize14 textcolor1 text-white">Hiral Krupesh . Founder & Creative Director . Carat
												Craft
												Jewellery</p>
											<h4 class="size32 textcolor1 mt-0 mb30 text-white">I HIGHLY RECOMMEND PIXTAR IF YOU ARE LOOKING TO
												REVAMP AND
												ELEVATE YOUR BRAND</h4>
											<p class="size18 textcolor3 d-md-block d-sm-none d-none text-white">“ Lorem ipsum dolor sit amet,
												consetetur sadipscing elitr, sed diam
												nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At
												vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata
												sanctus est.”</p>
										</div>
									</div>
									<div class="col-md-12 d-md-none d-sm-block d-block  mt-sm-4 mt-3 ">
										<div class="slidecontent">
											<p class="size18 textcolor3 text-white">“ Lorem ipsum dolor sit amet, consetetur sadipscing elitr,
												sed diam
												nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At
												vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata
												sanctus est.”</p>
										</div>
									</div>
								</div>
							</div>
						</ng-template>
						<ng-template carouselSlide [id]="baseUrl">
							<div class="col-md-9 col-sm-11 col-11 mx-auto">
								<div class="row justify-content-center">
									<div class="col-lg-3 col-md-5 col-sm-5">
										<div class="imgblk">
											<img class="mx-auto" src="{{baseUrl}}/img/home/crystal-story.png" alt="Branding and web development agency">
										</div>
									</div>
									<div class="col-lg-8 col-md-7 offset-lg-1 col-sm-7 mt-sm-0 mt-3">
										<div class="slidecontent">
											<p class="fontsize14 textcolor1 text-white">Hiral Krupesh . Founder & Creative Director . Carat Craft
												Jewellery</p>
											<h4 class="size32 textcolor1 mt-0 mb30 text-white">I HIGHLY RECOMMEND PIXTAR IF YOU ARE LOOKING TO REVAMP AND
												ELEVATE YOUR BRAND</h4>
											<p class="size18 textcolor3 d-md-block d-sm-none d-none text-white">“ Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
												nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At
												vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata
												sanctus est.”</p>
										</div>
									</div>
									<div class="col-md-12 d-md-none d-sm-block d-block mt-sm-4 mt-3">
										<div class="slidecontent">
											<p class="size18 textcolor3 text-white">“ Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
												nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At
												vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata
												sanctus est.”</p>
										</div>
									</div>
								</div>
							</div>
						</ng-template>
					</ng-container>
				</owl-carousel-o>

			</div>
		</div>
	</div>
</section> -->
<app-testimonial></app-testimonial>
<!-- Successful story sections-->
<!-- Faq section Starts -->
<section class="section bannerdrk faqsection">
	<div class="container">
		<div class="row">
			<div class="col-md-10 col-sm-11 col-11 m-auto">
				<div class="row">
					<div
						class="col-lg-4 col-md-6 col-sm-6"
						data-aos="fade-up"
						data-aos-duration="1000"
						data-aos-delay="100"
					>
						<div class="creative">
							<h2 class="">
								Frequently <br />
								Asked <br />
								Questions… <br />
							</h2>
						</div>
					</div>
					<div
						class="col-lg-7 offset-lg-1 col-md-6 col-sm-6"
						data-aos="fade-up"
						data-aos-duration="1000"
						data-aos-delay="100"
					>
						<div class="d-block">
							<div class="custom-collapse footer-collapse">
								<div class="accordion" id="accordionExample1">
									<div class="accordion-item">
										<h3 class="accordion-header" id="headingOne">
											<button
												class="accordion-button collapsed brdtp"
												type="button"
												data-bs-toggle="collapse"
												data-bs-target="#collapseOne"
												aria-expanded="false"
												aria-controls="collapseOne"
											>
												Why not just hire a full-time designer?
											</button>
										</h3>
										<div
											id="collapseOne"
											class="accordion-collapse collapse"
											aria-labelledby="headingOne"
											data-bs-parent="#accordionExample1"
										>
											<!-- show class removed  -->
											<div class="accordion-body">
												Good question! Hiring a senior-level designer now costs
												upwards of $50,000–$80,000 annually—plus benefits—and
												that’s if you can even find one available. Plus, keeping
												a full-time designer often means paying for downtime
												when there’s no work. <br /><br />
												With our monthly plan, you can pause and resume your
												subscription anytime, so you’re only paying for design
												when you actually need it.
											</div>
										</div>
									</div>

									<div class="accordion-item">
										<h3 class="accordion-header" id="headingTwo">
											<button
												class="accordion-button collapsed"
												type="button"
												data-bs-toggle="collapse"
												data-bs-target="#collapseTwo"
												aria-expanded="false"
												aria-controls="collapseTwo"
											>
												Is there a limit to my design requests?
											</button>
										</h3>
										<div
											id="collapseTwo"
											class="accordion-collapse collapse"
											aria-labelledby="headingTwo"
											data-bs-parent="#accordionExample1"
										>
											<div class="accordion-body">
												Nope! Once you’re subscribed, feel free to add as many
												design requests to your queue as you need—they’ll be
												delivered one at a time.
											</div>
										</div>
									</div>

									<div class="accordion-item">
										<h3 class="accordion-header" id="headingThree">
											<button
												class="accordion-button collapsed"
												type="button"
												data-bs-toggle="collapse"
												data-bs-target="#collapseThree"
												aria-expanded="false"
												aria-controls="collapseThree"
											>
												How fast can I expect my designs?
											</button>
										</h3>
										<div
											id="collapseThree"
											class="accordion-collapse collapse"
											aria-labelledby="headingThree"
											data-bs-parent="#accordionExample1"
										>
											<div class="accordion-body">
												Most requests are turned around within 48 hours. Typical
												requests like banners, brochures, flyers, event themes,
												and social templates usually take about two days, though
												bigger projects may take a little longer. If your
												request is on the larger side, you can expect steady
												progress every 24 hours until it’s complete.
											</div>
										</div>
									</div>

									<div class="accordion-item">
										<h3 class="accordion-header" id="headingFour">
											<button
												class="accordion-button collapsed"
												type="button"
												data-bs-toggle="collapse"
												data-bs-target="#collapseFour"
												aria-expanded="false"
												aria-controls="collapseFour"
											>
												Who’s doing the design work?
											</button>
										</h3>
										<div
											id="collapseFour"
											class="accordion-collapse collapse"
											aria-labelledby="headingFour"
											data-bs-parent="#accordionExample1"
										>
											<div class="accordion-body">
												Surprise! Pixtar is a tight-knit team of nine, and our
												founder is hands-on with every project. This means
												you’ll work directly with Pixtar’s founder. For
												specialized requests, like animations or custom
												illustrations, we collaborate with our trusted partner
												designers.
											</div>
										</div>
									</div>

									<div class="accordion-item">
										<h3 class="accordion-header" id="headingFive">
											<button
												class="accordion-button collapsed"
												type="button"
												data-bs-toggle="collapse"
												data-bs-target="#collapseFive"
												aria-expanded="false"
												aria-controls="collapseFive"
											>
												How does the pause feature work?
											</button>
										</h3>
										<div
											id="collapseFive"
											class="accordion-collapse collapse"
											aria-labelledby="headingFive"
											data-bs-parent="#accordionExample1"
										>
											<div class="accordion-body">
												We get it—sometimes you don’t have a full month’s worth
												of design needs. With the pause feature, you can stop
												your subscription anytime. Here’s how it works: Billing
												runs on a 31-day cycle. Let’s say you’ve used the
												service for 21 days, then decide to pause. This leaves
												you with 10 days of service, which you can pick up
												anytime in the future.
											</div>
										</div>
									</div>
									<div class="accordion-item">
										<h3 class="accordion-header" id="headingSix">
											<button
												class="accordion-button collapsed"
												type="button"
												data-bs-toggle="collapse"
												data-bs-target="#collapseSix"
												aria-expanded="false"
												aria-controls="collapseSix"
											>
												What about larger projects?
											</button>
										</h3>
										<div
											id="collapseSix"
											class="accordion-collapse collapse"
											aria-labelledby="headingSix"
											data-bs-parent="#accordionExample1"
										>
											<div class="accordion-body">
												No problem! Larger requests, like full website or app
												designs, are delivered in parts. We break them down on
												our end and deliver portions every 24–48 hours until
												everything’s complete.
											</div>
										</div>
									</div>
									<div class="accordion-item">
										<h3 class="accordion-header" id="headingSeven">
											<button
												class="accordion-button collapsed brdbtm"
												type="button"
												data-bs-toggle="collapse"
												data-bs-target="#collapseSeven"
												aria-expanded="false"
												aria-controls="collapseSeven"
											>
												Which design tools do you use?
											</button>
										</h3>
										<div
											id="collapseSeven"
											class="accordion-collapse collapse"
											aria-labelledby="headingSeven"
											data-bs-parent="#accordionExample1"
										>
											<div class="accordion-body">
												We work primarily with Adobe Illustrator, Photoshop, and
												XD to create your designs.
											</div>
										</div>
									</div>
									<div class="accordion-item">
										<h3 class="accordion-header" id="headingEight">
											<button
												class="accordion-button collapsed brdbtm"
												type="button"
												data-bs-toggle="collapse"
												data-bs-target="#collapseEight"
												aria-expanded="false"
												aria-controls="collapseEight"
											>
												How do I send design requests?
											</button>
										</h3>
										<div
											id="collapseEight"
											class="accordion-collapse collapse"
											aria-labelledby="headingEight"
											data-bs-parent="#accordionExample1"
										>
											<div class="accordion-body">
												We make it easy! You can request designs in Trello by
												adding a card, sharing Google Docs or wireframes, or
												even by sending a quick Loom video (perfect if you’d
												rather talk through your ideas than write them out). If
												it can be shared or linked in Trello, it’s fair game.
											</div>
										</div>
									</div>
									<div class="accordion-item">
										<h3 class="accordion-header" id="headingNine">
											<button
												class="accordion-button collapsed brdbtm"
												type="button"
												data-bs-toggle="collapse"
												data-bs-target="#collapseNine"
												aria-expanded="false"
												aria-controls="collapseNine"
											>
												What if the design isn’t quite right?
											</button>
										</h3>
										<div
											id="collapseNine"
											class="accordion-collapse collapse"
											aria-labelledby="headingNine"
											data-bs-parent="#accordionExample1"
										>
											<div class="accordion-body">
												No problem! We’ll work with you to revise the design
												until it’s exactly what you’re looking for.
											</div>
										</div>
									</div>
									<div class="accordion-item">
										<h3 class="accordion-header" id="headingTen">
											<button
												class="accordion-button collapsed brdbtm"
												type="button"
												data-bs-toggle="collapse"
												data-bs-target="#collapseTen"
												aria-expanded="false"
												aria-controls="collapseTen"
											>
												Are there any types of design you don’t cover?
											</button>
										</h3>
										<div
											id="collapseTen"
											class="accordion-collapse collapse"
											aria-labelledby="headingTen"
											data-bs-parent="#accordionExample1"
										>
											<div class="accordion-body">
												Yes, there are a few: 3D modeling, animated graphics
												(like GIFs), document design (medical forms, for
												example), complex packaging, extensive print designs
												(such as magazines or books), and Adobe InDesign
												documents aren’t included in our offerings.
											</div>
										</div>
									</div>
									<div class="accordion-item">
										<h3 class="accordion-header" id="headingEleven">
											<button
												class="accordion-button collapsed brdbtm"
												type="button"
												data-bs-toggle="collapse"
												data-bs-target="#collapseEleven"
												aria-expanded="false"
												aria-controls="collapseEleven"
											>
												What if I only need a single design?
											</button>
										</h3>
										<div
											id="collapseEleven"
											class="accordion-collapse collapse"
											aria-labelledby="headingEleven"
											data-bs-parent="#accordionExample1"
										>
											<div class="accordion-body">
												That’s totally fine! You can pause your subscription
												whenever you’re done and resume when you have new design
												needs—no wasted time.
											</div>
										</div>
									</div>
									<div class="accordion-item">
										<h3 class="accordion-header" id="headingTweleve">
											<button
												class="accordion-button collapsed brdbtm"
												type="button"
												data-bs-toggle="collapse"
												data-bs-target="#collapseTweleve"
												aria-expanded="false"
												aria-controls="collapseTweleve"
											>
												Are refunds available if I’m not satisfied with the
												service?
											</button>
										</h3>
										<div
											id="collapseTweleve"
											class="accordion-collapse collapse"
											aria-labelledby="headingTweleve"
											data-bs-parent="#accordionExample1"
										>
											<div class="accordion-body">
												Due to the high-quality nature of the work, we don’t
												offer refunds.
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<!-- Media Carosual Popup -->
<!-- <ng-template #videomodal let-modal style="z-index: 0;">
	<button type="button" class="btn" aria-describedby="modal-title" (click)="modal.dismiss('Cross click')"><span
			class="fa fa-times" aria-hidden="true"></span></button>
	<video class=" h-auto desktopimg" id="myVideo3" style="width: 100%; height:100%;" autoplay="true" loop="true"
		oncanplay="this.play()" controls>
		<source src="{{baseUrl}}/what is brandng pixtar 2.mp4" type="video/mp4">
		<source src="{{baseUrl}}/what is brandng pixtar 2.mp4" type="video/ogg">
		Your browser does not support HTML5 video.
	</video>
</ng-template> -->

<!-- Payment Popup -->
<ng-template #payments let-modal style="z-index: 0">
	<div class="modal-header">
		<h2 class="modal-title weight500 size32" id="modal-basic-title">
			<strong>{{ paymentData.name }}</strong>
		</h2>
		<p><strong>Complete Your Payment</strong></p>
		<!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<span aria-hidden="true">
				×
			</span>
		</button> -->
	</div>
	<div class="modal-body">
		<div id="content">
			<div class="container">
				<div class="row">
					<div class="col-md-12">
						<div class="">
							<form
								[formGroup]="paymentForm"
								method="post"
								(ngSubmit)="submitPayment()"
								novalidate
							>
								<div class="row mrl-0 mb-3" style="padding: 5px 5px">
									<div class="form-floating mb-3">
										<input
											type="text"
											name="firstname"
											autocomplete="off"
											formControlName="firstname"
											class="form-control"
											id="floatingInput"
											placeholder="firstname"
										/>
										<label for="floatingInput" class="mt-0"
											>What's your First Name?</label
										>
										<div
											*ngIf="
												isPaymentSubmitted && hasError('firstname', 'required')
											"
											class="error"
										>
											<div>First Name is required.</div>
										</div>
									</div>
									<div class="form-floating mb-3">
										<input
											type="text"
											name="lastname"
											autocomplete="off"
											formControlName="lastname"
											class="form-control"
											id="floatingInput"
											placeholder="lastname"
										/>
										<label for="floatingInput" class="mt-0"
											>What's your Last Name?</label
										>
										<div
											*ngIf="
												isPaymentSubmitted && hasError('lastname', 'required')
											"
											class="error"
										>
											<div>Last Name is required.</div>
										</div>
									</div>
									<div class="form-floating mb-3">
										<input
											type="email"
											name="email"
											autocomplete="off"
											formControlName="email"
											class="form-control"
											id="floatingInput"
											placeholder="email"
										/>
										<label for="floatingInput" class="mt-0"
											>What’s your e-mail?</label
										>
										<div
											*ngIf="
												isPaymentSubmitted && hasEmailError('email', 'required')
											"
											class="error"
										>
											<div>
												{{ hasEmailError("email", "required") }}
											</div>
										</div>
									</div>
									<div class="form-floating mb-3">
										<!-- <input type="number" name="referred_phone" autocomplete="off" formControlName="referred_phone"
											class="form-control" id="floatingInput" placeholder="name" min="0"> -->
										<ngx-intl-tel-input
											class="form-control interphone"
											id="floatingInput"
											[cssClass]="''"
											[enableAutoCountrySelect]="true"
											[enablePlaceholder]="true"
											[searchCountryFlag]="true"
											[preferredCountries]="preferredCountries"
											[searchCountryField]="[
												SearchCountryField.Iso2,
												SearchCountryField.Name
											]"
											[selectFirstCountry]="false"
											[selectedCountryISO]="CountryISO.UnitedArabEmirates"
											[tooltipField]="TooltipLabel.Name"
											[phoneValidation]="true"
											[separateDialCode]="true"
											name="contact"
											formControlName="contact"
										>
										</ngx-intl-tel-input>
										<label for="floatingInput" class="mt-0"
											>Contact Number</label
										>
										<div
											*ngIf="
												isPaymentSubmitted &&
												hasPhoneNumberError('contact', 'required')
											"
											class="error"
										>
											<div>
												{{ hasPhoneNumberError("contact", "required") }}
											</div>
										</div>
									</div>
									<div class="form-floating mb-3">
										<input
											type="text"
											name="company"
											autocomplete="off"
											formControlName="company"
											class="form-control"
											id="floatingInput"
											placeholder="company"
										/>
										<label for="floatingInput" class="mt-0"
											>What's your Company Name?</label
										>
										<div
											*ngIf="
												isPaymentSubmitted && hasError('company', 'required')
											"
											class="error"
										>
											<div>Company name is required.</div>
										</div>
									</div>
									<div class="form-floating mb-3">
										<input
											type="text"
											name="website"
											autocomplete="off"
											formControlName="website"
											class="form-control"
											id="floatingInput"
											placeholder="website"
										/>
										<label for="floatingInput" class="mt-0"
											>What's your Company Website?</label
										>
									</div>
									<!-- <div class="form-floating mb-3">
										<textarea type="text" name="company_address" autocomplete="off" formControlName="company_address"
											class="form-control" id="floatingInput" placeholder="company address"></textarea>
										<label for="floatingInput" class="mt-0">What's your Company Address?</label>
									</div> -->
									<div
										class="d-flex justify-content-center align-items-center mt-4"
									>
										<!-- <div class="text-center text-sm-start me-3">
											<input type="submit" name="submit" value="Submit" class=" submit">
										</div>
										<div class="input-group1">
											<button type="cancel" class="button text-center" (click)="closePopUp()">Cancel</button>
										</div> -->
										<div
											class="cstprng-table-cta position-relative mtrem3 started"
										>
											<!-- <div class="position-absolute customcrl">
												<p>
													<a class="cstbtn" (click)="submitPayment()">
														<span class="text text128"> Submit</span>
														<span class="borderspan"
															><i
																class="fa fa-chevron-right"
																aria-hidden="true"
															></i>
														</span>
													</a>
												</p>
											</div> -->

											<div class="linkToPackages">
												<button
													(click)="submitPayment()"
													class="d-flex justify-content-start align-items-center"
												>
													<span class="text semibold text-capitalize">
														submit
													</span>
													<i class="fa fa-chevron-right" aria-hidden="true"></i>
													<span class="borderspan"> </span>
												</button>
											</div>

											<p class="size14 cntlink">
												Or
												<button
													(click)="closePopUp()"
													class="text-decoration-underline"
												>
													cancel
												</button>
											</p>
										</div>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-template>
<!-- <button type="button" class="btn btn-primary" (click)="openModal()">Open Contact Form</button> -->
<!-- Modal Structure -->
<div
	class="modal fade"
	id="contactModal"
	tabindex="-1"
	aria-labelledby="modalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header">
				<h2 class="modal-title weight500 size32" id="modal-basic-title">
					<strong>REFERRAL</strong>
				</h2>
				<p><strong>REFER A FRIEND & EARN</strong></p>
				<!-- <h5 class="modal-title" id="modalLabel">REFER A FRIEND & EARN</h5>
				<button type="button" class="close" aria-label="Close" (click)="closeModal()">
					<span aria-hidden="true">
						×
					</span>
				</button> -->
			</div>
			<div class="modal-body">
				<form
					[formGroup]="referralForm"
					method="post"
					(ngSubmit)="submitReferral()"
				>
					<div class="row mrl-0 mb-3" style="padding: 5px 5px">
						<h4><strong>Your Details:</strong></h4>
						<div class="form-floating mb-3">
							<input
								type="text"
								name="referrer_name"
								autocomplete="off"
								formControlName="referrer_name"
								class="form-control"
								id="floatingInput"
								placeholder="your name"
							/>
							<label for="floatingInput" class="mt-0">Full Name</label>
							<div
								*ngIf="
									submitted && hasReferralError('referrer_name', 'required')
								"
								class="error"
							>
								<div>Your Name is required.</div>
							</div>
						</div>
						<div class="form-floating mb-3">
							<input
								type="email"
								name="referrer_email"
								autocomplete="off"
								formControlName="referrer_email"
								class="form-control"
								id="floatingInput"
								placeholder="email"
							/>
							<label for="floatingInput" class="mt-0">Email Address</label>
							<div
								*ngIf="submitted && hasEmailError('referrer_email', 'required')"
								class="error"
							>
								<div>
									{{ hasEmailError("referrer_email", "required") }}
								</div>
							</div>
						</div>
						<div class="form-floating mb-3">
							<!-- <input type="number" name="referrer_phone" autocomplete="off" formControlName="referrer_phone"
								class="form-control" id="floatingInput" placeholder="name" min="0"> -->
							<ngx-intl-tel-input
								class="form-control interphone"
								id="floatingInput"
								[cssClass]="''"
								[enableAutoCountrySelect]="true"
								[enablePlaceholder]="true"
								[searchCountryFlag]="true"
								[preferredCountries]="preferredCountries"
								[searchCountryField]="[
									SearchCountryField.Iso2,
									SearchCountryField.Name
								]"
								[selectFirstCountry]="false"
								[selectedCountryISO]="CountryISO.UnitedArabEmirates"
								[tooltipField]="TooltipLabel.Name"
								[phoneValidation]="true"
								[separateDialCode]="true"
								name="referrer_phone"
								formControlName="referrer_phone"
							>
							</ngx-intl-tel-input>
							<label for="floatingInput" class="mt-0">Contact Number</label>
							<div
								*ngIf="
									submitted && hasPhoneNumberError('referrer_phone', 'required')
								"
								class="error"
							>
								<div>
									{{ hasPhoneNumberError("referrer_phone", "required") }}
								</div>
							</div>
						</div>
						<h4><strong>Your Friend’s Details:</strong></h4>
						<div class="form-floating mb-3">
							<input
								type="text"
								name="referred_name"
								autocomplete="off"
								formControlName="referred_name"
								class="form-control"
								id="floatingInput"
								placeholder="name"
							/>
							<label for="floatingInput" class="mt-0">Full Name</label>
							<div
								*ngIf="
									submitted && hasReferralError('referred_name', 'required')
								"
								class="error"
							>
								<div>Your Friend’s Name is required.</div>
							</div>
						</div>
						<div class="form-floating mb-3">
							<input
								type="email"
								name="referred_email"
								autocomplete="off"
								formControlName="referred_email"
								class="form-control"
								id="floatingInput"
								placeholder="email"
							/>
							<label for="floatingInput" class="mt-0">Email Address</label>
							<div
								*ngIf="submitted && hasEmailError('referred_email', 'required')"
								class="error"
							>
								<div>
									{{ hasEmailError("referred_email", "required") }}
								</div>
							</div>
						</div>
						<div class="form-floating mb-3">
							<!-- <input type="number" name="referred_phone" autocomplete="off" formControlName="referred_phone"
								class="form-control" id="floatingInput" placeholder="name" min="0"> -->
							<ngx-intl-tel-input
								class="form-control interphone"
								id="floatingInput"
								[cssClass]="''"
								[enableAutoCountrySelect]="true"
								[enablePlaceholder]="true"
								[searchCountryFlag]="true"
								[preferredCountries]="preferredCountries"
								[searchCountryField]="[
									SearchCountryField.Iso2,
									SearchCountryField.Name
								]"
								[selectFirstCountry]="false"
								[selectedCountryISO]="CountryISO.UnitedArabEmirates"
								[tooltipField]="TooltipLabel.Name"
								[phoneValidation]="true"
								[separateDialCode]="true"
								name="referred_phone"
								formControlName="referred_phone"
							>
							</ngx-intl-tel-input>
							<label for="floatingInput" class="mt-0">Contact Number</label>
							<div
								*ngIf="
									submitted && hasPhoneNumberError('referred_phone', 'required')
								"
								class="error"
							>
								<div>
									{{ hasPhoneNumberError("referred_phone", "required") }}
								</div>
							</div>
						</div>
						<div class="d-flex justify-content-center align-items-center mt-4">
							<!-- <div class="text-center text-sm-start me-3">
								<input type="submit" name="submit" value="Submit" class=" submit">
							</div>
							<div class="input-group1">
								<button type="cancel" class="button text-center" (click)="closeModal()">Cancel</button>
							</div> -->
							<div class="cstprng-table-cta position-relative mtrem3 started">
								<!-- <div class="position-absolute customcrl">
									<p>
										<a class="cstbtn" (click)="submitReferral()">
											<span class="text text128"> Submit</span>
											<span class="borderspan"
												><i class="fa fa-chevron-right" aria-hidden="true"></i>
											</span>
										</a>
									</p>
								</div> -->

								<div class="linkToPackages">
									<button
										(click)="submitReferral()"
										class="d-flex justify-content-start align-items-center"
									>
										<span class="text semibold text-capitalize"> submit </span>
										<i class="fa fa-chevron-right" aria-hidden="true"></i>
										<span class="borderspan"> </span>
									</button>
								</div>
								<p class="size14 cntlink">
									Or
									<button
										(click)="closeModal()"
										class="text-decoration-underline"
									>
										cancel
									</button>
								</p>
							</div>
						</div>
					</div>
				</form>

				<!-- Success Message -->
				<!-- <div *ngIf="successMessage" class="alert alert-success mt-3" role="alert">
					{{ successMessage }}
				</div> -->

				<!-- Error Message -->
				<div *ngIf="errorMessage" class="alert alert-danger mt-3" role="alert">
					{{ errorMessage }}
				</div>

				<!-- Loading Indicator -->
				<div
					*ngIf="isLoading && !isEmailSame && !isContactSame"
					class="alert alert-info mt-3"
					role="alert"
				>
					Sending your message, please wait...
				</div>
				<!-- Error Message -->
				<div *ngIf="isContactSame" class="alert alert-danger mt-3" role="alert">
					Referrer and referred Contact Number cannot be the same
				</div>
				<!-- Error Message -->
				<div *ngIf="isEmailSame" class="alert alert-danger mt-3" role="alert">
					Referrer and referred emails cannot be the same
				</div>
			</div>
		</div>
	</div>
</div>
